import { ILocationService } from "angular";
import { ConfirmationService } from 'primeng/api';
import { LogBookRootScopeService } from "../shared/model/app.model";

angular.module('logbook')
    .controller('home', ['$location', '$rootScope', 'pConfirmationService',
        function($location: ILocationService, $rootScope: LogBookRootScopeService, pConfirmationService: ConfirmationService) {
            $location.path($rootScope.user && $rootScope.user.validationRequired ?
                '/validation-required' :
                '/logs'
            );
            
            if ($location.search().emailValidationFailed) {
                pConfirmationService.confirm({
					message: 'Could not validate your email. Please request another validation email from the User Settings menu.',
					header: 'Email Validation Failed',
					icon: 'pi pi-exclamation-triangle',
					key: 'close',
					rejectVisible: false,
					acceptLabel: 'Okay'
				});
			}
			
            if ($location.search().emailValidationSuccess && !$rootScope.user?.validationRequired) {
                pConfirmationService.confirm({
					message: `Thank you! Your email has been validated. You may now access any logs other users have shared with ${$location.search().email}.`,
					header: 'Email Validated',
					icon: 'pi pi-check-circle',
					key: 'close',
					rejectVisible: false,
					acceptLabel: 'Okay'
				});
			}
			
            if ($location.search().emailValidationSuccess && $rootScope.user?.validationRequired) {
                pConfirmationService.confirm({
					message: 'You now have a LogBook account. Click the button below to sign in.',
					header: 'Welcome to LogBook!',
					icon: 'pi pi-check-circle',
					key: 'no-close',
					acceptLabel: 'Start Logging!',
					accept: () => $rootScope.logout()
				});
			}
			
            $location.search('emailValidationFailed', null)
            		 .search('emailValidationSuccess', null)
            		 .search('email', null);
        }
    ]);